import styled from 'styled-components'

export const Wrapper = styled.div`
  border-top: 1px solid #e2e5e8;
  padding-top: 20px;
`
